import script from "./CompanyIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&setup=true&lang=js"

import "./CompanyIntro.vue?vue&type=style&index=0&id=01e06e8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e06e8f"]])

export default __exports__